<template>
  <div class="tabbed" :id="id">
    <div class="mx-auto tablist_section w-5/6 mobile:w-full mobile-sides">
      <div class="tabbed_desc mobile:basis-full basis-1/2 font-responsive mr-auto mobile-sides">
        <h2 v-html="component_data.params.title"></h2>
        <p
          class="w-4/5"
          v-for="(text, index) in texts(component_data.params)"
          v-html="text"
          :key="index"
        ></p>
      </div>
      <ul class="tablist w-1/2 mobile:w-full mobile:flex-wrap" role="tablist" :ref="'tablist_'+id">
        <li role="presentation" v-for="tab in tabs" :key="tab.id">
          <a
            :ref="tab.id"
            :href="'#panel_'+tab.id"
            :id="tab.id"
            :tabindex="!isActive(tab.id) ? -1 : 0"
            :aria-selected="isActive(tab.id)"
            role="tab"
            v-html="tab.params.tabname"
            class="tab"
            @click="tabClick(tab.id, $event)"
            @keydown="tabControls(tab.id, $event)"
          ></a>
        </li>
      </ul>
    </div>
    <div class="tabs_wrapper">
      <section
        role="tabpanel"
        class="tabpanel"
        tabindex="-1"
        aria-labelledby="tab.id"
        v-for="tab in tabs"
        :key="'panel_'+tab.id"
        :ref="'panel_'+tab.id"
        :id="'panel_'+tab.id"
        :hidden="!isActive(tab.id)"
      >
        <div class="tabpanel_inner">
          <mid :component_data="componentify(tab, defaultComponent)"></mid>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["component_data"],
    data() {
      return {
        tabs: [],
        current: "",
        id: "",
        defaultComponent: "text_right"
      };
    },
    methods: {
      tabControls(id, $e) {
        switch ($e.key) {
          case "ArrowLeft":
            this.goToTab(id, -1);
            break;
          case "ArrowRight":
            this.goToTab(id, 1);
            break;
          case "Tab":
            if (!$e.shiftKey) {
              $e.preventDefault();
              this.$refs["panel_" + id][0].focus();
            }
            break;
          default:
            break;
        }
      },

      isActive(id) {
        return id == this.current;
      },

      goToTab(id, iterator) {
        let index = 0;

        for (var i = 0; i < this.tabs.length; i += 1) {
          if (this.tabs[i].id === id) {
            index = i;
          }
        }

        switch (index + iterator) {
          case this.tabs.length:
            index = 0;
            break;
          case -1:
            index = this.tabs.length - 1;
            break;
          default:
            index = index + iterator;
            break;
        }

        this.select(this.tabs[index].id);
      },

      select(id) {
        this.current = id;
        this.$refs[id][0].focus();
      },

      tabClick(id, $e) {
        $e.preventDefault();

        this.current = id;
        $e.target.focus();
      },

      focus(ref, $e) {
        $e.preventDefault();
        this.$refs[ref][0].focus();
      }
    },
    mounted() {
      this.id = this.component_data.id;
      this.tabs = this.component_data.params.tabs;
      this.current = this.tabs[0].id;
      this.defaultComponent = this.component_data.params.default_tab
        ? this.component_data.params.default_tab
        : "text_right";
    },
    created() {}
  };
</script>

<style scoped>
.tablist_section {
  display: flex;
  margin-bottom: -106px;
}
.tabbed_desc {
}
.tabbed_desc h2 {
  font-size: 4.2em;
  margin: 0;
  margin-bottom: 1em;
  color: #e41429;
  font-weight: 700;
  font-family: "Uni Neue", sans-serif;
}
.tabbed_desc p {
  font-size: 2em;
  line-height: 1.8em;
  margin: 1em 0;
  font-family: "Lato", sans-serif;
}
.tablist {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin: 0;
  padding: 0 1em;
  margin-bottom: 106px;
}

.tablist li {
  display: inline-block;
  margin: 0 1em;
}

.tablist a.tab {
  display: block;
  text-decoration: none;
  color: #857f72;
  padding: 6px 0;
  font-weight: 700;
  font-family: "Uni Neue", sans-serif;
}

.tablist a:focus {
  outline: none;
}

a.tab {
  position: relative;
}

a.tab svg {
  width: 68px;
  height: 68px;
}

a.tab[aria-selected],
a.tab:focus {
  color: #e41429;
}
.tab[aria-selected]::after,
.tab:focus::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 4px 4px 0px 0px / 4px 4px 0px 0px;
  width: 100%;
  height: 1px;
  box-shadow: 0 0 0 0.2px #e41429;
  background-color: #e41429;
}

.tabs_wrapper {
  display: flex;
  margin-bottom: 60px;
}

.tabs_wrapper .tabpanel {
  max-width: 0;
  transition: all 0.8s ease-out;
}

.tabs_wrapper .tabpanel[hidden] {
  display: inline-block !important;
  /* transition-delay: .4s; */
  opacity: 0;
  transform: translateX(-60px);
  pointer-events: none;
}

@media (max-width: 992px) {
  .tablist {
    order: 3;
    display: flex;
    flex-direction: column;
    padding: 0;
    width: 100%;
    justify-content: space-around;
    flex-direction: row;
    font-size: .8em;
  }

  .tablist li {
    margin: 0;
  }

  .tabs_wrapper {
    width: calc(100% - 80px);
  }

  .tablist_section {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .tabs_wrapper {
    margin-bottom: 15px;
  }
}

@media (max-width: 550px) {
}
</style>


<style>
</style>
